'use es6';

export const GMAIL = 'GMAIL';
export const OUTLOOK = 'OUTLOOK';
export const HUBSPOT_HOSTED = 'HUBSPOT_HOSTED';